<template>
  <div>
    <section>
      <el-row type="flex" :gutter="4">
        <el-col :span="5">
          <el-date-picker
              v-model="times"
              @change="findAllData(activeTabName)"
              :clearable="false"
              type="daterange"
              range-separator="-"
              start-placeholder="Ngày bắt đầu"
              end-placeholder="Ngày kết thúc">
          </el-date-picker>
        </el-col>
        <el-col :span="3">
          <el-select
              style="width: 100%; margin-left: 30px"
              filterable
              clearable
              v-model="dataFilter.transferType"
              placeholder="Loại giao dịch"
              @change="findAllData(activeTabName)"
          >
            <el-option
                v-for="item in transferTypeList"
                :key="item.id"
                :value="item.value"
                :label="item.label"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input
              @clear="findAllData(activeTabName)"
              clearable
              style="width: 100%; margin-left: 40px"
              placeholder="Nhập số tài khoản"
              v-model="dataFilter.accountNumber"
              @keyup.enter.native="findAllData(activeTabName)"
              type="number"
          >
            <template #append>
              <el-button
                  v-if="activeTabName !== 'school'"
                  icon="el-icon-search"
                  @click="findAllData(activeTabName)"
              ></el-button>
            </template>
          </el-input>
        </el-col>
        <el-col :span="2">
          <!-- chọn khối -->
          <el-select
              clearable
              v-if="activeTabName === 'school'"
              @change="handleChangeGrade"
              class=" input-grade"
              style="width: 160px; margin-left: 40px"
              v-model="dataFilter.idGrade"
              placeholder="Chọn khối"
          >
            <el-option
                v-for="(item,index) in gradeList"
                :key="index"
                :value="item.id"
                :label="item.gradeName"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <!-- chọn lớp -->
          <el-select
              v-if="activeTabName === 'school'"
              style="width: 160px; margin-left: 70px"
              v-model="dataFilter.idClass"
              @change="findAllData(activeTabName)"
              placeholder="Chọn lớp"
          >
            <el-option
                v-for="item in classList"
                :key="item.id"
                :value="item.id"
                :label="item.className"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" v-if="activeTabName === 'school'">
          <el-input
              @clear="findAllData(activeTabName)"
              clearable
              style="width: 100%; margin-left: 40px"
              placeholder="Nhập tên học sinh"
              v-model="dataFilter.name"
              @keyup.enter.native="findAllData(activeTabName)"
          >
            <template #append>
              <el-button
                  icon="el-icon-search"
                  @click="findAllData(activeTabName)"
              ></el-button>
            </template>
          </el-input>
        </el-col>
      </el-row>
    </section>
    <!--  Danh sách bảng  -->
    <section style="margin-top: 20px">
      <el-tabs type="card" @tab-click="handleClickTab" v-model="activeTabName">
        <el-tab-pane label="Trường" name="school">
          <el-table
              ref="multipleTable"
              :empty-text="tableEmpty"
              v-loading="loading.table"
              :element-loading-text="tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :data="dataTable"
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChange"
              :max-height="tableMaxHeight"
              border
              :summary-method="getSummaries"
              show-summary
          >
            <el-table-column
                type="selection"
                width="55"
                align="center"
            />

            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            >

            </el-table-column>
            <el-table-column
                fixed
                width="200"
                label="ID giao dịch"
                align="left"
                prop="transactionId"
            >
            </el-table-column>
            <el-table-column width="300" fixed="left" label="Tên học sinh">
              <template v-slot:default="scope">
                <el-tooltip placement="top">
                  <div slot="content">Mã học sinh: {{ scope.row.kidCode }}<br>Lớp: {{ scope.row.className }}
                  </div>
                  <span>{{ scope.row.fullName }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
                label="Số tài khoản ngân hàng"
                align="left"
                prop="accountNumber"
                width="200"
            >
            </el-table-column>
            <el-table-column
                label="Tên tài khoản"
                align="left"
                prop="nameAccount"
                width="300"
            >
            </el-table-column>
            <el-table-column
                prop="transactionDate"
                label="Thời gian nhận giao dịch"
                width="200"
                align="left">
              <template #default="{ row }">
                {{ formatDate(row.transactionDate) }}
              </template>
            </el-table-column>
            <el-table-column
                label="Tên ngân hàng"
                align="left"
                prop="nameBank"
                width="300"
            >
            </el-table-column>
            <el-table-column
                label="ID VA "
                align="center"
                prop="idVa"
                width="200"
            >
            </el-table-column>
            <el-table-column
                label="Số VA"
                align="center"
                prop="va"
                width="200"
            >
            </el-table-column>
            <el-table-column
                label="Mã tham chiếu FT"
                align="center"
                prop="referenceNumber"
                width="200"
            >
            </el-table-column>
            <el-table-column
                label="Nội dung ngân hàng"
                align="left"
                prop="transactionContent"
                width="500"
            >
            </el-table-column>
            <el-table-column
                label="Mã thanh toán"
                align="center"
                prop="paymentCode"
                width="200"
            >
            </el-table-column>
            <el-table-column
                label="Loại giao dịch"
                align="center"
                prop="transferType"
                width="200"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.transferType === 'credit'" class="credit">Tiền vào</span>
                <span v-if="scope.row.transferType === 'debit'"  class="debit">Tiền ra</span>
              </template>
            </el-table-column>
            <el-table-column
                label="Nội dung giao dịch"
                align="left"
                prop="contentOGV"
                width="500"
            >
            </el-table-column>
            <el-table-column
                label="Số tiền giao dịch"
                align="center"
                prop="amount"
                width="300"
            >
              <template slot-scope="scope">
                <span> {{ scope.row.amount | formatCurrency }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="Trạng thái gửi webhook "
                align="center"
                prop="receiveWebhook"
                width="200"
            >
              <template slot-scope="scope">
            <span v-if="scope.row.receiveWebhook === true" style="color: #09f209"><i
                class="el-icon-circle-check"></i>Thành công</span>
                <span v-if="scope.row.receiveWebhook === false" style="color: #ee4f4f"><i
                    class="el-icon-circle-close"></i>Thất bại</span>
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex">
            <el-col :span="22" style=" margin: 15px 0">
              <div class="container_nav_page">
                <el-pagination
                    background
                    layout="prev, pager, next, sizes"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentPageChange"
                    :current-page.sync="dataFilter.page"
                    :page-sizes="listSizePage"
                    :total="totalPage">
                </el-pagination>
              </div>
            </el-col>
            <el-col :span="2">
              <div style="float: right; margin: 15px 0">
                <el-dropdown @command="handleCommand">
                  <el-button class="button-bottom" type="success">
                    Tác vụ
                    <i class="el-icon-caret-bottom"/>
                  </el-button>
                  <el-dropdown-menu>
                    <el-dropdown-item command="exportExcel"
                    >Xuất excel
                    </el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Ngoài trường" name="outSchool">
          <el-table
              ref="multipleTable"
              :empty-text="tableEmpty"
              v-loading="loading.table"
              :element-loading-text="tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :data="dataTable"
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChange"
              :max-height="tableMaxHeight"
              border
              :summary-method="getSummaries"
              show-summary
          >
            <el-table-column
                type="selection"
                width="55"
                align="center"
            />

            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            >

            </el-table-column>
            <el-table-column
                fixed
                width="200"
                label="ID giao dịch"
                align="left"
                prop="transactionId"
            >
            </el-table-column>
            <el-table-column width="150" fixed="left" label="Tên học sinh">
              <template v-slot:default="scope">
                <el-tooltip placement="top">
                  <div slot="content">Mã học sinh: {{ scope.row.kidCode }}<br>Lớp: {{ scope.row.className }}
                  </div>
                  <span>{{ scope.row.fullName }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
                label="Số tài khoản ngân hàng"
                align="left"
                prop="accountNumber"
                width="200"
            >
            </el-table-column>
            <el-table-column
                label="Tên tài khoản"
                align="left"
                prop="nameAccount"
                width="300"
            >
            </el-table-column>
            <el-table-column
                prop="transactionDate"
                label="Thời gian nhận giao dịch"
                width="200"
                align="left">
              <template #default="{ row }">
                {{ formatDate(row.transactionDate) }}
              </template>
            </el-table-column>
            <el-table-column
                label="Tên ngân hàng"
                align="left"
                prop="nameBank"
                width="300"
            >
            </el-table-column>
            <el-table-column
                label="ID VA "
                align="center"
                prop="idVa"
                width="200"
            >
            </el-table-column>
            <el-table-column
                label="Số VA"
                align="center"
                prop="va"
                width="200"
            >
            </el-table-column>
            <el-table-column
                label="Mã tham chiếu FT"
                align="center"
                prop="referenceNumber"
                width="200"
            >
            </el-table-column>
            <el-table-column
                label="Nội dung giao dịch"
                align="left"
                prop="transactionContent"
                width="500"
            >
            </el-table-column>
            <el-table-column
                label="Mã thanh toán"
                align="center"
                prop="paymentCode"
                width="200"
            >
            </el-table-column>
            <el-table-column
                label="Loại giao dịch"
                align="center"
                prop="transferType"
                width="200"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.transferType === 'credit'" class="credit">Tiền vào</span>
                <span v-if="scope.row.transferType === 'debit'"  class="debit">Tiền ra</span>
              </template>
            </el-table-column>
            <el-table-column
                label="Số tiền giao dịch"
                align="center"
                prop="amount"
                width="300"
            >
              <template slot-scope="scope">
                <span> {{ scope.row.amount | formatCurrency }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="Trạng thái gửi webhook "
                align="center"
                prop="receiveWebhook"
                width="200"
            >
              <template slot-scope="scope">
            <span v-if="scope.row.receiveWebhook === true" style="color: #09f209"><i
                class="el-icon-circle-check"></i>Thành công</span>
                <span v-if="scope.row.receiveWebhook === false" style="color: #ee4f4f"><i
                    class="el-icon-circle-close"></i>Thất bại</span>
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex">
            <el-col :span="22" style=" margin: 15px 0">
              <div class="container_nav_page">
                <el-pagination
                    background
                    layout="prev, pager, next, sizes"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentPageChange"
                    :current-page.sync="dataFilter.page"
                    :page-sizes="listSizePage"
                    :total="totalPage">
                </el-pagination>
              </div>
            </el-col>
            <el-col :span="2">
              <div style="float: right; margin: 15px 0">
                <el-dropdown @command="handleCommand">
                  <el-button class="button-bottom" type="success">
                    Tác vụ
                    <i class="el-icon-caret-bottom"/>
                  </el-button>
                  <el-dropdown-menu>
                    <el-dropdown-item command="exportExcel"
                    >Xuất excel
                    </el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>

    </section>

  </div>
</template>

<script>

import moment from "moment/moment";
import sePayConnectionService from "@/services/SePayConnectionService";
import {exportExcelSepay} from "@/commonFuncion/ExportExcelSepay";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import GradeService from "@/services/GradeService";
import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";

export default {
  data() {
    return {
      activeTabName: "school",
      dataTable: [],
      loading: {
        table: false,
      },
      gradeList:[],
      classList:[],
      schoolList: [],
      dataFilter: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        transferType: "",
        accountNumber: "",
        name: "",
        idClass: "",
        idGrade: "",
        page: 1,
        limit: 50,

      },
      times: [],
      listSizePage: [50, 100, 200, 300, 500, 1000, 2000, 3000, 5000],
      totalPage: 0,
      transferTypeList: [
        {id: 1 , value: "credit", label: "Tiền vào"},
        {id: 2 , value: "debit", label: "Tiền ra"},
      ],
      listData: [],
      exportToExcelData: {
        titleFile: 'THỐNG KÊ LỊCH SỬ GIAO DỊCH',
        columnWidths: [10, 50, 50, 30, 30, 30, 30, 30, 30, 20, 20, 20, 50, 20, 20, 30, 30], // Chiều rộng của từng cột
        nameFile: 'Thong_ke_lich_su_giao_dich_' + moment().format("DD-MM-YYYY_hh-mm-ss"),
      },
    }
  },
  created() {
    this.getAllGrade();
    const today = moment().format('YYYY-MM-DD');
    const tenDaysAgo = moment().subtract(10, 'days').format('YYYY-MM-DD');
    this.dataFilter.startDate = tenDaysAgo;
    this.dataFilter.endDate = today;
    this.times = [this.dataFilter.startDate, this.dataFilter.endDate];
    this.findAllData(this.activeTabName)
  },

  computed: {
    tableLoading() {
      return this.$tableLoading;
    },

    tableMaxHeight() {
      return this.$tableMaxHeight || 600
    },

    tableEmpty() {
      return this.$tableEmpty
    },

    completeExportToExcelData() {
      return {
        ...this.exportToExcelData,
        companyInfo: [],
      }
    },
    titleFileWithDateRange() {
      const start = moment(this.dataFilter.startDate).format('DD-MM-YYYY');
      const end = moment(this.dataFilter.endDate).format('DD-MM-YYYY');
      return `THỐNG KÊ LỊCH SỬ GIAO DỊCH TỪ ${start} ĐẾN ${end}`;
    }
  },

  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff; font-weight: bold;";
    },
    handleClickTab(tab) {
      if (tab.name === "school") {
        this.findAllData(this.activeTabName);
      }
      if (tab.name === "outSchool") {
        this.findAllData(this.activeTabName);
      }
      this.dataFilter.limit = 50
      this.dataFilter.page = 1
    },
    exportExcelSepay,
    formatDate (iso) {
      const d = new Date(iso)
      const pad = n => String(n).padStart(2, '0')
      return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())} `
          + ` - ${pad(d.getDate())}/${pad(d.getMonth()+1)}/${d.getFullYear()}`
    },

    handleSelectionChange(value) {
      this.listData = []
      for (let i = 0; i < value.length; i++) {
        if (value[i].transferType === "credit") {
          value[i].transferType = 'Tiền vào'
        } else {
          value[i].transferType = 'Tiền ra'
        }
        this.listData.push(value[i]);
      }
    },
    /**
     * Lấy dữ liệu
     */
    async findAllData(value){
      this.dataFilter.startDate = moment(this.times[0]).format('YYYY-MM-DD');
      this.dataFilter.endDate = moment(this.times[1]).format('YYYY-MM-DD');
      this.loading.table = true;
      if (value === 'school') {
        await sePayConnectionService.getTransactionHistoryForPlus(this.dataFilter.startDate, this.dataFilter.endDate, this.dataFilter.transferType, this.dataFilter.accountNumber,
            this.dataFilter.name, this.dataFilter.idClass ,this.dataFilter.limit, this.dataFilter.page).then(res => {
          this.dataTable = res.data.data.responseList
          this.totalPage = res.data.data.total
          this.loading.table = false
        }).catch(err => {
          console.log(err);
        })
      } else {
        await sePayConnectionService.getTransactionHistoryForPlusOutSchool(this.dataFilter.startDate, this.dataFilter.endDate, this.dataFilter.transferType, this.dataFilter.accountNumber,
            this.dataFilter.limit, this.dataFilter.page).then(res => {
          this.dataTable = res.data.data.responseList
          this.totalPage = res.data.data.total
          this.loading.table = false
        }).catch(err => {
          console.log(err);
        })
      }

    },
    /**
     * Tác vụ
     */
    async handleCommand(command) {
      if (command === "exportExcel") {
        await this.handleExportExcel();
      }
    },
    async handleExportExcel() {
      const title = this.titleFileWithDateRange;
      const fileName = this.exportToExcelData.nameFile;
      this.exportToExcelData.titleFile = title;
      this.exportToExcelData.nameFile = fileName;
      if (this.listData.length > 0){
        this.$confirm(
            " Bạn có chắc chắn muốn xuất file hiện tại?",
            "Thông báo!",
            {
              confirmButtonText: "Có",
              cancelButtonText: "Không",
            }
        ).then(async () => {
          await this.exportExcelSepay(this.completeExportToExcelData, this.listData, "plus").then(() =>{
        NotifyMessage.leftCornerNotificationSuccess("Xuất file thành công")
          })
        })
      }else {
        NotifyMessage.leftCornerNotificationError("Không có dữ liệu!")
      }
    },
    /**
     * Phân trang
     */
    handleSizeChange(value) {
      this.dataFilter.limit = value;
      this.findAllData(this.activeTabName);
    },
    handleCurrentPageChange(value) {
      this.dataFilter.page = value;
      this.findAllData(this.activeTabName);
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (this.activeTabName === 'school'){
          if (index === 14) {
            sums[index] = "Tổng cộng"; // Cột ghi chữ "Tổng cộng"
            return;
          }

          if (index === 15) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + value;
                } else {
                  return prev;
                }
              }, 0).toLocaleString("vi-VN", {
                style: "currency",
                currency: "VND"
              });
            } else {
              sums[index] = '';
            }
          } else {
            sums[index] = ''; // Không cộng các cột khác
          }
        } else {
          if (index === 13) {
            sums[index] = "Tổng cộng"; // Cột ghi chữ "Tổng cộng"
            return;
          }

          if (index === 14) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + value;
                } else {
                  return prev;
                }
              }, 0).toLocaleString("vi-VN", {
                style: "currency",
                currency: "VND"
              });
            } else {
              sums[index] = '';
            }
          } else {
            sums[index] = ''; // Không cộng các cột khác
          }
        }

      });
      return sums;
    },
    /**
     * Lấy khối
     */
    getAllGrade() {
      GradeService.getGradeInPrinciple()
          .then((resp) => {
            this.gradeList = resp.data.data;
          })
          .catch((err) => {
            console.log(err);
            NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!")
          });
      this.handleChangeGrade()
    },
    /**
     * thay đổi khối
     */

    handleChangeGrade() {
      financeKidsV2Service
          .getClassInGrade(this.dataFilter.idGrade)
          .then((resp) => {
            resp.data && resp.data.data ? this.classList = resp.data.data : this.classList = []
            this.classList.length > 0 ? this.dataFilter.idClass = this.classList[0].id : this.dataFilter.idClass = null
            this.findAllData(this.activeTabName);
          })
          .catch((err) => {
            NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!")
            console.log(err);
          });
    },

  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #78a5e7;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 10px 0;
}

/deep/ .el-table .cell {
  line-height: 15px;
}

/deep/ .el-table th > .cell {
  font-size: 13px;
}

/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}


.button-bottom {
  border-radius: 0;
  margin-left: 3px;
}

.button-click {
  float: right;
  margin: 20px 0 40px 0;
}


.over-table {
  width: 97%;
  margin: 0 auto;
}

.table-data {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;

}

.wrapper-table {
  height: 600px;
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

thead {
  background: #78a5e7;
  color: white;
  font-weight: bold;
}

tbody {
  color: #606266;
  font-size: 14px;
  overflow: auto;
  font-family: Arial, Helvetica, sans-serif;

}

td {
  padding: 12px;
}

.table-index {
  width: 10px;
  text-align: center;
}

.table-item-name {
  width: 200px;
  text-align: center;
}

.table-action {
  width: 200px;
  text-align: center;
}

/deep/ .el-table .cell {
  overflow-y: auto !important;
  white-space: pre-line;
  line-height: 20px;
  word-break: break-word;
  max-height: 156px !important;
}

.color-text-reply {
  color: #4177e2;
}

.input-data {
  width: 60%;
}

.disable-row {
  background: #e4e7ed;
}

.sub_menu {
  /deep/ .el-submenu__title {
    height: 40px;
    display: flex;
    align-items: center;
  }

  /deep/ i {
    color: #FFFFFF;
    margin-top: 0 !important;
  }
}
.el-dropdown-menu {
  position: absolute;
  background-color: #5fb44a;
  border-radius: 0;
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

.button-bottom {
  border-radius: 0;
  margin-left: 3px;
}

.credit {
  color: #0070C0;
  font-weight: 500;
}

.debit {
  color: #d9534f; /* Màu đỏ nhấn mạnh hơn */
  font-weight: 500;
}
.container_nav_page {
  display: flex;
  justify-content: center;
}
/deep/ .el-table__footer-wrapper tbody td.el-table__cell, .el-table__header-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #F5F7FA;
  color: #0957f4;
}

/deep/ .el-table__fixed-footer-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #F5F7FA;
  color: #0957f4;
}
</style>